import { createSlice } from '@reduxjs/toolkit';
import isEmpty from '../../common/js/components/is-empty';
import jwt_decode from 'jwt-decode';
import Debug from '../../common/js/utils/Debug';

const initialState = {
  user: {
    parsing: true,
    error: false,
    tpInfo: {},
    aadInfo: {},
  },
  isAuthenticated: false,
};

export const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAdminxUser: (state, action) => {
      const userInfo = action.payload;
      state.isAuthenticated = !isEmpty(userInfo.data);
      if (userInfo.type == 'aadInfo') {
        state.user.aadInfo = userInfo.data;
      } else {
        state.user.tpInfo = userInfo.data;
      }
    },
    setParseTpToken: (state, action) => {
      const tpToken = action.payload;
      try {
        if (tpToken) {
          let decodedToken = jwt_decode(tpToken);
          let decodedHpId = decodedToken.hpid_token ? jwt_decode(decodedToken.hpid_token) : {};
          let session = {
            ...decodedToken,
            loading: false,
            id: decodedToken.user || '',
            firstName: decodedToken.given_name || '',
            lastName: decodedToken.family_name || '',
            fullName: decodedToken.name || '',
            tenant: decodedToken.tenant || '',
            sub: decodedToken.sub || '',
            email: decodedToken.email || '',
            authority: decodedToken.authority || '',
            token: tpToken,
            hpidToken: decodedToken.hpid_token,
            decodedHpIdToken: decodedHpId,
            exp: decodedToken.exp,
            selectedCompanies: [],
            tenant_type: decodedToken.tenant_type,
            current_user_id: decodedToken.user,
            current_tenant_id: decodedToken.tenant,
            lastActive: new Date().getTime(),
            ...('explicit_impersonator' in decodedToken &&
              Object.keys(decodedToken.explicit_impersonator).length > 0 && { isUserImpersonated: true }),
            ...('explicit_impersonator' in decodedToken &&
              Object.keys(decodedToken.explicit_impersonator).length > 0 && {
                explicit_impersonator_tenant: decodedToken.explicit_impersonator ? decodedToken.explicit_impersonator.tenant : '',
              }),
            ...('explicit_impersonator' in decodedToken &&
              Object.keys(decodedToken.explicit_impersonator).length > 0 && {
                explicit_impersonator_user: decodedToken.explicit_impersonator ? decodedToken.explicit_impersonator.user : '',
              }),
            ...('explicit_impersonator' in decodedToken &&
              Object.keys(decodedToken.explicit_impersonator).length > 0 && {
                explicit_impersonator_tenant_type: decodedToken.explicit_impersonator
                  ? decodedToken.explicit_impersonator.tenant_type
                  : '',
              }),
            organisationName: decodedToken.organization,
            app_site: decodedToken.app_site,
            iss: decodedToken.iss,
            canAccessTechPulse: true,
            canAccessAdminx: true,
          };
          if (decodedToken && decodedToken.externalOrgRefIDs && decodedToken.externalUserRefIDs) {
            try {
              let externalUserRefIDsArray = decodedToken.externalUserRefIDs || [];
              let externalOrgRefIDsArray = decodedToken.externalOrgRefIDs || [];

              externalOrgRefIDsArray = externalOrgRefIDsArray.filter((x) => {
                return x.type === 'EXTERNAL_ORG_IDENTIFIER_TYPE_TECHPULSE';
              });

              if (externalOrgRefIDsArray.length === 0) {
                externalOrgRefIDsArray = [
                  {
                    value: decodedToken.tenants[0].tenant_id,
                    type: 'EXTERNAL_ORG_IDENTIFIER_TYPE_TECHPULSE',
                  },
                ];
              }

              externalUserRefIDsArray = externalUserRefIDsArray.filter((x) => {
                if (externalOrgRefIDsArray[0] && externalOrgRefIDsArray[0].value && x.external_data) {
                  return (
                    x.type === 'EXTERNAL_USER_IDENTIFIER_TYPE_TECHPULSE' &&
                    x.external_data.tenantId === externalOrgRefIDsArray[0].value
                  );
                } else {
                  return x.type === 'EXTERNAL_USER_IDENTIFIER_TYPE_TECHPULSE';
                }
              });

              let _user =
                externalUserRefIDsArray[0] && externalUserRefIDsArray[0].value
                  ? externalUserRefIDsArray[0].value
                  : decodedToken.sub;
              let _tenant =
                externalOrgRefIDsArray[0] && externalOrgRefIDsArray[0].value
                  ? externalOrgRefIDsArray[0].value
                  : decodedToken.tenants[0].tenant_id;
              let ecpTenantIds = '';
              if (decodedToken.externalOrgRefIDs && decodedToken.externalOrgRefIDs.length) {
                ecpTenantIds = decodedToken.externalOrgRefIDs.filter((tenant) => {
                  return tenant.type === 'EXTERNAL_ORG_IDENTIFIER_TYPE_STRATUS';
                });
              }
              let assignVal = {
                id: _user,
                user: _user,
                sub: _user,
                user_id: _user,
                current_user_id: _user,
                tenant: _tenant,
                current_tenant_id: _tenant,
                ecpTenantId: ecpTenantIds && ecpTenantIds[0] ? ecpTenantIds[0].value : null,
                onecloud_token: true,
              };
              let userDetailsOc = JSON.parse(localStorage.getItem('user_details_oc')) || {};
              session = {
                ...session,
                ...assignVal,
                ...userDetailsOc,
              };
            } catch (err) {
              Debug.log('Exception in updateSessionForOC', err);
            }
          }
          state.user.tpInfo = session;
          state.user.token = action.payload;
        } else {
          state.user.tpInfo = {};
          state.isAuthenticated = false;
          state.user.parsing = false;
          state.user.error = false;
        }
      } catch (e) {
        Debug.log('Failed to parse JWT token' + e);
        state.user.tpInfo = {};
        state.isAuthenticated = false;
        state.user.parsing = false;
        state.user.error = true;
      }
    },
    setParseAADToken: (state, action) => {
      const aadToken = action.payload;
      try {
        if (aadToken) {
          let decodedToken = jwt_decode(aadToken);
          let session = Object.assign(decodedToken, { token: aadToken });
          state.user.aadInfo = session;
          state.isAuthenticated = true;
        } else {
          state.user.aadInfo = {};
          state.isAuthenticated = false;
          state.user.parsing = false;
          state.user.error = false;
        }
      } catch (e) {
        Debug.log('Failed to parse JWT token');
        state.user.aadInfo = {};
        state.isAuthenticated = false;
        state.user.parsing = false;
        state.user.error = true;
      }
    },
    removeAccess: (state, action) => {
      state.user.tpInfo = Object.assign(state.user.tpInfo, action.payload);
    },
    signOutUser: (state, action) => {
      state.user.parsing = true;
      state.user.error = false;
      state.user.tpInfo = action.payload;
      state.user.aadInfo = action.payload;
      state.isAuthenticated = false;
    },
  },
});

export const { setAdminxUser, setParseTpToken, setParseAADToken, removeAccess, signOutUser } = authReducer.actions;

export default authReducer.reducer;
